import { DependencyInjectionContainer } from "@src/cloud-connect/dependency-injection-container/dependency-injection-container";
import {
  registerAlarmProfiles,
  registerAlarmProfilesReferenceCopy,
} from "@src/cloud-connect/dependency-injection-container/get-alarm-profiles";
import { registerInitialStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-initial-structure-nodeset";
import {
  getLogger,
  registerLogger,
} from "@src/cloud-connect/dependency-injection-container/get-logger";
import { registerMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { registerNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";
import {
  getPermissionsSetService,
  registerPermissionsSetService,
} from "@src/cloud-connect/dependency-injection-container/get-permissions-set-service";
import {
  getRolesPermissionsService,
  registerRolesPermissionsService,
} from "@src/cloud-connect/dependency-injection-container/get-roles-permissions-service";
import { registerTileCollection } from "@src/cloud-connect/dependency-injection-container/get-tile-collection";
import { registerVersionStringBuilder } from "@src/cloud-connect/dependency-injection-container/get-version-string-builder";
import { useSyncFeatureFlagsWithAuthContext } from "@src/cloud-connect/feature-toggles/hooks/use-sync-feature-flags-with-auth-context";
import { useLoadUnits } from "@src/cloud-connect/timeseries/hooks/use-load-units";
import { rolesPermissionsFile } from "@src/cloud-connect/roles-permissions/repositories/roles-permissions-file";
import { RolesPermissionsFileRepository } from "@src/cloud-connect/roles-permissions/repositories/roles-permissions-file-repository";
import { logoutTimer } from "@src/cloud-connect/utils/logout-timer";
import { useEffect } from "react";

const registerServices = (): DependencyInjectionContainer => {
  const dependencyInjectionContainter =
    DependencyInjectionContainer.getInstance();

  registerVersionStringBuilder();
  registerLogger();
  const logger = getLogger();
  logger.setDebugLevel(false);
  registerNodeManager();

  registerInitialStructureNodeset();
  registerMachineStructureNodeset();

  registerTileCollection();
  registerAlarmProfiles();
  registerAlarmProfilesReferenceCopy();

  registerRolesPermissionsService();
  // TODO: either file or api
  getRolesPermissionsService().setRolesPermissionsRepository(
    new RolesPermissionsFileRepository(rolesPermissionsFile),
  );

  registerPermissionsSetService();
  getPermissionsSetService().setPermissionsSet(new Set<string>([]));

  return dependencyInjectionContainter;
};

const logWelcomeMessage = () => {
  getLogger().info("Initialising app!");
};

export const useAppHook = (): DependencyInjectionContainer => {
  const dic = registerServices();
  useSyncFeatureFlagsWithAuthContext();
  useLoadUnits();

  useEffect(() => {
    logWelcomeMessage();
    logoutTimer();
  }, []);

  return dic;
};
